// MED-5617: Engine uses a special form of ISO format with 6 digit millisecond notation
export function DateToEngineISOString(date: Date): string {
    const isoString = date.toISOString(); // Standard ISO: e.g., "2025-05-09T22:00:00.000Z"

    // Replace the milliseconds part `.000Z` with `.000000Z` (add extra zeros)
    return isoString.replace(/\.([0-9]{3})Z$/, '.$1000Z');
}
